import React from 'react';
import { WhisperSpinner as WhisperSpinner$1 } from 'react-spinners-kit';

var style = {"container":"whisper-spinner-module_container__UEXer","active":"whisper-spinner-module_active__vK7V7","spinner":"whisper-spinner-module_spinner__VFO-g","message":"whisper-spinner-module_message__WncJk","ellipsis":"whisper-spinner-module_ellipsis__wyCVu"};

function WhisperSpinner(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: style.container + " " + (props.isLoading ? style.active : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: style.spinner
  }, /*#__PURE__*/React.createElement(WhisperSpinner$1, {
    size: 80,
    frontColor: '#004763',
    backColor: '#015473'
  }), /*#__PURE__*/React.createElement("div", {
    className: style.message + " " + (props.message ? style.active : '')
  }, props.message)));
}

export { WhisperSpinner };
